import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { size, uniqueId } from 'lodash';
import cn from 'classnames';
import {
  Checkbox,
  createBemBlockBuilder,
  PasswordInput,
  TextArea,
  TextInput,
} from '@ebsco-ui/ebsco-ui';
import CharacterCounter from '@ebsco-new-ui/character-counter';

import { PropsWithClassName } from '@app/constants';

import { FieldProps } from './constants';

import './FormField.scss';

const cnBem = createBemBlockBuilder(['formField']);

export const FieldWrapper: FC<
  PropsWithClassName<
    FieldProps & {
      component:
        | typeof TextInput
        | typeof PasswordInput
        | typeof TextArea
        | typeof Checkbox;
    }
  >
> = ({
  id = uniqueId('form-field-'),
  className,
  component: Component,
  label,
  name,
  control,
  rules = {},
  defaultValue = '',
  characterLimit = 0,
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field,
        fieldState: { error, isTouched },
        formState: { isSubmitted },
      }) => {
        const fieldError =
          isSubmitted || isTouched ? error?.message : undefined;
        const component = (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <Component
            id={id}
            label={label}
            {...(fieldError && { error: fieldError })}
            {...props}
            {...field}
          />
        );

        return (
          <div className={cn(cnBem(), className)}>
            {component}
            {characterLimit > 0 && (
              <CharacterCounter
                characterLength={size(field.value)}
                characterLimit={characterLimit}
                messages={{
                  charactersRemaining: {
                    id: 'projects.charactersRemaining',
                    defaultMessage:
                      '{charactersRemaining} characters remaining',
                  },
                }}
              />
            )}
          </div>
        );
      }}
    />
  );
};
